<style lang="less" scoped>
  @import "~$views/less/var.less";
  @item_height: 32px;
  @left_fn1_width: 288px;
  .function__wraper {
    padding: 0 18px;
    display: flex;
    margin-bottom: 4px;
    user-select: none;
    .hex__remove{
      /*display: none;*/
    }
    &>.right{
      margin-left: 12px;
      max-width: calc(50% - 6px);
    }
  }
  .import {
    cursor: pointer;
    margin-left: 10px;
    display: flex;
    &:hover svg{
      fill: #FC8830;
    }
    svg {
      width: 16px;
      height:16px;
      fill:#2c2c2c;
    }
  }
  .detail {
    .func__item{
      margin-bottom: 0px;
    }
  }
  .left {
    height:32px;
    background:rgba(255,255,255,1);
    border-radius:2px;
    flex: none;
    display: flex;
    justify-content: space-around;
    align-items: center;
    .remove {
      visibility: hidden;
      margin-right: 9px;
    }
    &:hover {
      .remove {
        visibility: visible;
      }
    }
  }
  .right {
    flex: 1;
    /*width: 297px;*/
    /*flex: none;*/
    display: flex;
    flex-flow: column;
    margin-left: 0px;
  }
  .func__item {
    display: flex;
    align-items: center;
    height:32px;
    background:rgba(255,255,255,1);
    border-radius:2px;
    .remove {
      visibility: hidden;
      margin-right: 9px;
    }
    &:hover {
      .remove {
        visibility: visible;
      }
    }
  }
  .title {
    font-size: 12px;
    display: flex;
    flex-grow: 1;
    margin-left: 16px;
    .text{
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      // outline-color: #FA883D;
      // outline-width: 2px;
      width: 1px;
      flex-grow: 1;
      outline: none;
      &.edit{
        min-height: 18px;
      }
    }
    .cont{
      margin-right: 8px;
      min-width: 26px;
      color: #bfbfbf;
      text-align: center;
    }
    input.text {
      appearance: none;
      border: none;
      outline: none;
      padding: 0;
      margin: 0;
    }
    .highLight{
        color: #22D179;
    }
    .text[contenteditable] {
      text-overflow: clip;
    }
  }
  .tip{
    color: #BFBFBF;
    min-width: 26px;
    text-align: center;
    &.count {
      margin-right: 9px;
    }
    &:hover{
      cursor: move;
    }
  }
  .check {
    padding-left: 10px;
  }
  .fold{
    margin-right: 12px;
  }
  .remark__wrapper {
    display: flex;
    margin-right: 25px;
    width: 40px;
    .mark{
      display: none;
      text-align: left;
      padding: 0;
    }
    &:hover {
      .mark {
        display: inline-block;
      }
      [class^=remark] {
        display: none
      }
    }
  }
  .remark, .remark--un {
    width: 14px;
    height: 16px;
    background: url("./remark.svg") no-repeat 0 0;
    background-size: 100% 100%;
    display: inline-block;
  }
  .remark--un{
    background: url("./remark-un.svg") no-repeat 0 0;
  }
  .area{
    position: fixed;
    left: 0;
    top: 0;
    width: 276px;
    min-height: 146px;
    transform: translateX(-50%);
    border-radius: 8px;
    overflow: hidden;
    textarea{
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: calc(100% - 30px) !important;
      background: #FFECB3;
      padding: 16px 16px 30px;
      box-sizing: border-box;
      border:none;
      overflow: auto !important;
      resize: none;
    }
    .bottom{
      width: 100%;
      position: absolute;
      background: #FFECB3;
      bottom: 0px;
      border-top: 1px solid #e9d79f;
      height: 30px;
      line-height: 30px;
      display: flex;
      justify-content: flex-end;
      button{
        padding: 0 8px;
      }
      .save{
        color:#1890FF;
      }
      .del{
        color: #F5222D;
      }
    }
  }
</style>
<template>
  <div :class="{
    function__wraper: true,
    detail: detail
  }" :data-feat-index="index - 1" v-if="edit">

    <detail :edit="true" :fn="fns" :detail="detail" :class="{'active':selectItem._id===fns._id}" @select="selectThis(fns, index - 1)">
      <div :data-feat-index="index - 1" :id="wrapId(fns._id)" class="left">
        <div :data-feat-index="index - 1" class="check tip">{{ index }}</div>
        <div :data-feat-index="index - 1" class="title edit">
          <input :data-feat-index="index - 1" type="text" placeholder="新增1级功能" v-if="fns.isEdit" :ref='fns._id' :value="fns.name"
                 @keyup.enter.extract="saveItem(fns,1, $event, false)"
                 @blur.exact="saveItem(fns,1, $event, true)" class="text" />
          <div :data-feat-index="index - 1" :data-h-id="wrapId(fns._id)" v-else class="text" :class="{'search-highlight': isHighlight(fns, searchValue)}" v-html='highlight(fns, searchValue)'></div>
        </div>
        <remove @delete="onDelete(fns, index - 1)" class="remove" />
        <span v-show="!fold" class="tip count">{{ childCount }}</span>
        <!-- right down-->
        <a-icon @click="toggle" class="fold" :type="foldType" />
      </div>
    </detail>
    <div :data-feat-id="fns._id" :data-feat-index="index - 1" class="right">
      <draggable class="draggable" :data-feat-id="fns._id" :data-feat-index="index - 1" handle=".check.tip" ghost-class="ghost" @start="onStart" @end="onEnd" :move="checkMove" direction="vertical" group="fns" :list="fns.functions">
      <detail :data-feat-id="fns._id" :data-feat-index="index - 1" :data-func-index="idx"  @select="selectThis(fn, idx, fns, index - 1)" :fn="fn" :detail="detail" v-show="fold" v-for="(fn, idx) in fns.functions" :key="idx" class="func"  :class="{'active':selectItem._id===fn._id}">
        <div :data-feat-id="fns._id" :data-func-id="fn._id" :data-feat-index="index - 1" :data-func-index="idx" :id="wrapId(fn._id)" class="func__item">
          <div  :data-feat-id="fns._id" :data-func-id="fn._id"  :data-feat-index="index - 1" :data-func-index="idx" class="check tip">{{ `${index}.${(idx + 1)}`}}</div>
          <div class="title">
            <input type="text" placeholder="新增2级功能" v-if="fn.isEdit" :ref='fn._id' :value="fn.name"
                   @keyup.enter.extract="saveItem(fn,2, $event, false)"
                   @blur.extract="saveItem(fn,2, $event, true)" class="text" />
            <div  :data-feat-id="fns._id" :data-func-id="fn._id" :data-feat-index="index - 1" :data-func-index="idx" :data-h-id="wrapId(fns._id)" v-else class="text" :class="{'search-highlight': isHighlight(fn, searchValue)}" v-html='highlight(fn, searchValue)'></div>
          </div>
          <remove @delete="onDelete(fn, idx, fns, index - 1)" class="remove" />
<!--          <div class="remark__wrapper">-->
<!--            <i v-if="fn.remarks" class="remark"></i>-->
<!--            <i v-else class="remark&#45;&#45;un"></i>-->
<!--            <a-button class="mark" type="link" size="small" @click='remarks(fn)' :id='fn._id'>备注</a-button>-->
<!--          </div>-->
        </div>
      </detail>
      </draggable>
    </div>
    <div class="area" v-show='areaShow' :style='[positionXY]' v-click-outside="outSide">
      <a-textarea v-model='areaValue' placeholder="请输入备注" autosize/>
      <div class="bottom">
        <a-button class="save" @click='saveArea' type='link'>保存</a-button>
        <a-button class='del' @click='delArea' type='link'>删除</a-button>
      </div>
    </div>
  </div>
  <div :class="{
    function__wraper: true,
    detail: detail
  }" v-else>
    <detail @select='leftSelectThis(fns)' :detail="detail" :fn="fns" :class="{'active':leftSelectItem._id===fns._id}">
      <div :data-app-id="fns.app_id"  :id="wrapId(fns._id)" class="left" >
        <span class="import" @click="onChangeAll">
          <svg height="200" viewBox="0 0 1024 1024" width="200" xmlns="http://www.w3.org/2000/svg"><path d="m581.198769 475.411692a19.692308 19.692308 0 0 1 -8.664615 36.509539l-105.668923 105.708307a19.692308 19.692308 0 0 1 -27.884308-27.844923l77.784615-77.784615h-339.534769a19.692308 19.692308 0 1 1 0-39.384615h346.308923l-84.558769-84.519385a19.692308 19.692308 0 0 1 27.844923-27.844923l111.419077 111.379692c1.181538 1.181538 2.166154 2.441846 2.953846 3.780923zm-366.907077 154.742154a315.195077 315.195077 0 0 0 607.271385-118.153846 315.076923 315.076923 0 0 0 -588.012308-157.538462h46.631385a275.692308 275.692308 0 1 1 -22.882462 275.692308z" /></svg>
        </span>
        <!-- <a-checkbox :checked="getChecked(fns.isShow)" class="check" @change="onChangeAll"></a-checkbox> -->
        <div class="title">
          <span class="text">{{ fns.name }}</span>
          <span v-show="!fold" class="cont">{{ counts }}</span>
        </div>
<!--        <span class="tip count">{{ fns.functions.length }}</span>-->
        <!-- right down-->
        <a-icon @click="toggle" class="fold" :type="foldType" />
      </div>
    </detail>
    <div class="right">
      <detail @select='leftSelectThis(fn)' :fn="fn" :detail="detail" v-show="fold" v-for="(fn, idx) in fns.functions" :key="idx" class="func" :class="{'active':leftSelectItem._id===fn._id}">
        <div :data-app-id="fns.app_id" :id="wrapId(fn._id)" class="func__item">
          <span class="import" @click="onchangeItem(true, fn)">
            <svg height="200" viewBox="0 0 1024 1024" width="200" xmlns="http://www.w3.org/2000/svg"><path d="m581.198769 475.411692a19.692308 19.692308 0 0 1 -8.664615 36.509539l-105.668923 105.708307a19.692308 19.692308 0 0 1 -27.884308-27.844923l77.784615-77.784615h-339.534769a19.692308 19.692308 0 1 1 0-39.384615h346.308923l-84.558769-84.519385a19.692308 19.692308 0 0 1 27.844923-27.844923l111.419077 111.379692c1.181538 1.181538 2.166154 2.441846 2.953846 3.780923zm-366.907077 154.742154a315.195077 315.195077 0 0 0 607.271385-118.153846 315.076923 315.076923 0 0 0 -588.012308-157.538462h46.631385a275.692308 275.692308 0 1 1 -22.882462 275.692308z" /></svg>
          </span>
          <div class="title">
            <span class="text">{{fn.name}}</span>
          </div>
        </div>
      </detail>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import remove from '../delete.vue'
// import InputDiv from '../input/index'
import draggable from 'vuedraggable'
import detail from './detail.vue'
import vClickOutside from 'v-click-outside'
import { plus } from '@axe/precision'
export default {
  name: 'func',
  components: {
    remove,
    detail,
    draggable
  },
  directives: {
    clickOutside: vClickOutside.directive
  },
  props: {
    isFold: {
      type: Boolean,
      default: false
    },
    detail: {
      type: Boolean,
      default: false
    },
    edit: {
      type: Boolean,
      default: false
    },
    searchText: {
      type: String,
      default: ''
    },
    index: {
      type: [Number, String],
      default: 1
    },
    func: {
      type: Object,
      // required: true,
      default: function () {
        return {
          name: '个人中心哈哈哈哈哈哈哈哈哈哈哈哈哈',
          isShow: true,
          price: '20000',
          time: '10小时',
          functions: [
            {
              name: '个人设置',
              isShow: 1,
              price: '20000',
              time: '10小时'
            },
            {
              name: '我的订单',
              isShow: 0,
              price: '20000',
              time: '10小时'
            },
            {
              name: '收获地址',
              isShow: 1,
              price: '20000',
              time: '10小时'
            }
          ]
        }
      }
    },
    searchValue: {
      type: String
    },
    selectItem: {
      type: Object
    },
    leftSelectItem: {
      type: Object
    }
  },
  data () {
    return {
      fns: this.func,
      fold: this.isFold,
      areaValue: '',
      areaShow: false,
      areaItem: {},
      positionXY: { },
      drag: {
        start: 0,
        from: {
          featIndex: -1,
          funcIndex: -1,
          featId: null,
          funcId: null
        },
        to: {
          featIndex: -1,
          funcIndex: -1,
          featId: null,
          funcId: null
        }
      }
    }
  },
  mounted () {
    this.fns = this.formatData(this.func)
  },
  computed: {
    childCount () {
      return this.fns.functions ? this.fns.functions.length : 0
    },
    ...mapState('editor', [
      'viewMode',
      'functions'
    ]),
    foldType () {
      return this.fold ? 'caret-down' : 'caret-right' // 这个需要考虑下
    },
    checkCount () {
      if (this.fns && this.fns.functions) {
        return this.fns.functions.filter(x => Boolean(parseInt(x.isShow))).length
      }
      return 0
    },
    counts () {
      return `${this.childCount}`
    }
  },
  watch: {
    selectItem: {
      deep: true,
      handler (l, o) {
        if (l && l._id) {
          this.$nextTick(x => {
            if (this.selectItem && this.selectItem._id) {
              const wrapper = this.getWrapper()
              if (wrapper) {
                wrapper.scrollIntoView({ block: 'center', behavior: 'smooth' })
              }
              const element = this.getElement()
              element && element.focus()
            }
          })
        }
      }
    },
    func: {
      deep: true,
      handler (l, o) {
        if (l) this.fns = this.formatData(l)
      }
    },
    searchText (text, l) {
      if (!this.detail) return
      if (text !== l) {
        if (!text) {
          this.fns = this.func
        } else {
          this.fns.name = this.matched(this.fns.name, text)
          this.fns.functions.map(fn => {
            fn.name = this.matched(fn.name, text)
          })
        }
      }
    }
  },
  methods: {
    onStart (e) {
      this.drag.start = e.originalEvent.clientY
    },
    onEnd (e) {
      this.$emit('drag-end',
        this.drag.from, this.drag.to,
        e.to.getAttribute('data-feat-id'),
        e.originalEvent.clientY - this.drag.start > -15 ? 'down' : 'up')
      return true
    },
    checkMove (e) {
      const { draggedContext, relatedContext } = e
      this.drag.from = draggedContext
      this.drag.to = relatedContext
      return true
    },
    expand () {
      this.fold = true
    },
    getElement () {
      return document.querySelector(`#x${this.selectItem._id} input`)
    },
    getWrapper () {
      return document.querySelector(`#x${this.selectItem._id}`)
    },
    isHighlight (fns, searchValue) {
      if (!searchValue) return false
      if (fns && fns.name) {
        return fns.name.split(searchValue).length > 1
      }
    },
    highlight (fns, searchValue) {
      return fns && fns.name && fns.name.split(searchValue).join(`<span class="highLight" style="color:#FA883D">${searchValue}</span>`)
    },
    formatData (fns) {
      let init = {
        price: 0,
        time: 0,
        max_price: 0,
        min_price: 0,
        max_time: 0,
        min_time: 0
      }
      if (fns.functions) {
        const result = fns.functions.reduce((l, p) => {
          l.time = plus(l.time, p.time)
          l.price = plus(l.price, p.price)
          l.min_time = plus(l.min_time, p.min_time || p.time)
          l.max_time = plus(l.max_time, p.max_time || p.time)
          l.min_price = plus(l.min_price, p.min_price || p.price)
          l.max_price = plus(l.max_price, p.max_price || p.price)
          return l
        }, init)
        for (let k in result) {
          this.$set(fns, k, result[k])
        }
      }
      return fns
    },
    wrapId (id) {
      return `x${id}`
    },
    wrapFunc (fn) {
      fn.isEdit = false
      // eslint-disable-next-line no-return-assign
      fn.functions.map(f => f.isEdit = false)
    },
    onDelete (item, itemIndex, parent, parentIndex) {
      this.$emit('delete', item, itemIndex, parent, parentIndex)
    },
    onSelectFeat (feat, index) {
      this.$emit('selectFeat', feat, index - 1)
    },
    onSelectFunc (func, feat, index, idx) {
      this.$emit('selectFunc', func, feat, index - 1, idx)
    },
    matched (name, search) {
      if (this.edit) {
        return name.split(search).join(`<span>${search}</span>`)
      } else {
        return name
      }
    },
    toggle () {
      this.fold = !this.fold
    },
    foldClose () {
      this.fold = false
    },
    foldOpen () {
      this.fold = true
    },
    getChecked (show) {
      show = parseInt(show)
      return !!show
    },
    onChangeAll (e) {
      // this.fns.isShow = selected
      // const functions = this.fns.functions || EMPTY_LIST
      // eslint-disable-next-line no-return-assign
      // functions.forEach(x => x.isShow = selected)
      this.$emit('changeAll', true, this.fns, this.edit)
    },
    onchangeItem (checked, fn) {
      this.$emit('changeItem', checked, fn, this.fns, this.edit)
    },
    saveItem (item, type, e, loseFocus) {
      const element = this.getElement()
      const name = e.target.value || '新增功能'
      // 选中当前元素
      if (element) {
        if (name !== item.name) {
          item.name = name
          this.$event.$emit('appChangeName', type, item, name)
        }
        // eslint-disable-next-line no-return-assign
        loseFocus && this.$set(item, 'isEdit', false)
      }
    },
    // 只是切换到编辑模式
    changeEdit (item) {
      this.$set(item, 'isEdit', true)
      const element = this.getElement()
      // 选中当前元素
      if (element && document.activeElement !== element) {
        element.focus()
      }
    },
    selectThis (item, idx, parent, index) {
      this.$event.$emit('appSelectThis', item, idx, parent, index)
      this.changeEdit(item)
    },
    leftSelectThis (item) {
      this.$event.$emit('appLeftSelectThisItem', item)
    },
    remarks (item) {
      this.positionXY = { left: event.clientX + 'px', top: event.clientY + 'px' }
      this.areaShow = true
      this.areaValue = item.remarks || ''
      this.areaItem = item
    },
    saveArea () {
      this.areaItem.remarks = this.areaValue
      this.areaShow = false
      this.$post('/flow/api/5dea77fb473cd410ad5f5eee', { function_id: this.areaItem._id, remarks: this.areaValue }).then(result => {
      })
    },
    delArea () {
      this.areaItem.remarks = ''
      this.areaShow = false
      this.$post('/flow/api/5dea77fb473cd410ad5f5eee', { function_id: this.areaItem._id, remarks: '' }).then(result => {
      })
    },
    outSide () {
      const doms = event.path[0]
      const cla = doms.getAttribute('class')
      const id = doms.getAttribute('id')
      if (cla === null || cla.indexOf('mark') === -1 || id !== this.areaItem._id) {
        this.areaShow = false
      }
    }
  }
}
</script>
